/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import ContactForm from "../index/sub-components/ContactForm";

/* Data Imports */

import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "3rem 0rem 1rem 0rem",
  },
  heading: {
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "2.125rem",
    lineHeight: "3.1875rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  contactFormDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40%",
    },
  },
  illustrationSizer: {
    [theme.breakpoints.only("md")]: {
      height: "384px",
      width: "384px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "512px",
      width: "512px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "512px",
      width: "512px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "768px",
      width: "768px",
    },
  },
  illustration: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const GetInTouch = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.contactFormDiv}>
          <Typography variant="h1" component="span" className={classes.heading}>
            Get In Touch
          </Typography>
          <ContactForm />
        </div>
        <div className={classes.illustration}>
          <img
            src="/images/illustrations/single-property-page/get_in_touch.svg"
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default GetInTouch;
